import { render, staticRenderFns } from "./BuildPackage.vue?vue&type=template&id=63e23d12&scoped=true&"
import script from "./BuildPackage.vue?vue&type=script&lang=js&"
export * from "./BuildPackage.vue?vue&type=script&lang=js&"
import style0 from "./BuildPackage.vue?vue&type=style&index=0&id=63e23d12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e23d12",
  null
  
)

export default component.exports